/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.15.0
 */

import { useMemo } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { Button, LinkBlock } from '../../../../components/common';
import { ImgStatusSuccess } from '../../../../components/common/Block/Img';
import { ELinkTarget } from '../../../../components/common/ExternalLink/ExternalLink';
import { IRootReducer } from '../../../../reducers/rootReducer';
import {
    makeSelectOnboardingTranslation,
    makeSelectTranslationCommon,
} from '../../../internationalization/intSelectors';
import { ICommonTranslation, IOnboardingTranslation } from '../../../internationalization/types';
import { IOnboardingModalTranslation } from '../../../internationalization/types/modules/onboarding';
import Modal from '../../../modal/components/Modal';
import { ModalCenterStyled } from '../../../modal/components/styled/ModalCenterStyled';
import { IModalRenderProps } from '../../../modal/types/modalTypes';
import { EOnboardingModalId } from '../../types/onboardingTypes';
import { OnboardingModalLinkStyled } from './styled/OnboardingModalStyled';


const OnboardingModalFinal = ({
                                  onCloseModal,
                                  translationCommon,
                                  translationOnboarding,
                              }: IConnectedProps & Pick<IModalRenderProps, 'onCloseModal'>) => {

    const tLink: IOnboardingModalTranslation['link'] = useMemo(() => ({
        ...translationOnboarding.modal.default.link,
        ...translationOnboarding.modal[EOnboardingModalId.modalFinal].link,
    }), [translationOnboarding]);

    return (
        <Modal dataName="onboarding-final-modal" width="500px">
            <ModalCenterStyled>
                <ImgStatusSuccess/>
                <Modal.Title>
                    {translationOnboarding.modal[EOnboardingModalId.modalFinal].title}
                </Modal.Title>
                <Modal.Text>
                    <div
                        className="onboarding-modal__text"
                        dangerouslySetInnerHTML={{
                            __html: translationOnboarding.modal[EOnboardingModalId.modalFinal].text,
                        }}
                    />
                </Modal.Text>
                <Modal.Control>
                    <Button
                        kind="medium"
                        onClick={onCloseModal}
                    >
                        {translationCommon.modal.good}
                    </Button>
                </Modal.Control>
                <OnboardingModalLinkStyled>
                    <LinkBlock
                        isExternalUrl
                        target={ELinkTarget.BLANK}
                        url={tLink.url}
                    >
                        {tLink.label}
                    </LinkBlock>
                </OnboardingModalLinkStyled>
            </ModalCenterStyled>
        </Modal>
    );
};

export interface IConnectedProps {
    translationCommon: ICommonTranslation;
    translationOnboarding: IOnboardingTranslation;
}

export const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    translationCommon: makeSelectTranslationCommon(),
    translationOnboarding: makeSelectOnboardingTranslation(),
});

export default connect(mapStateToProps)(OnboardingModalFinal);
